import { MemberService } from './../../Services/member.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthService } from '../../Services/auth.service';
import { ClothesAdminListComponent } from '../clothes-admin-list/clothes-admin-list.component';
import { OrderService } from '../../Services/order.service';
import { ActivatedRoute } from '@angular/router';
import { ThrowStmt } from '@angular/compiler';
import { StockService } from '../../Services/stock.service';


@Component({
  selector: 'app-order',
  template: require('./order-form.component.html'),
  styles: [require('./order-form.component.css')]
})
export class OrderFormComponent implements OnInit {
  @ViewChild(ClothesAdminListComponent) clothesAdminList: ClothesAdminListComponent;
  noAdmin: string | null;

  constructor(private auth: AuthService, private memberService: MemberService, private orderService: OrderService, private route: ActivatedRoute, private stockService:StockService) { }

  members: any[] = [];
  stockUser:{} = {
    firstName : "",
    lastName: "",
    id: "-1"
  };
  nameSearchString: string = '';
  searched_members: any[] = [];
  firstnames: any[] = [];
  lastnames: any[] = [];

  current_member: any ={
    firstName: "",
    lastName: "",
    id: -1
  };

  isOpen = false;
  
  
  ngOnInit(){
    this.noAdmin = this.route.snapshot.paramMap.get('noadmin');
    this.orderService.getCurrentopenOrder().subscribe( x =>{
      if (x.status == 200){
        this.isOpen = true;
        if (this.checkIsAdmin()){
              this.loadAllMembers();     
              this.loadStockUser();
        } else {
            setTimeout(() => {
              this.current_member.firstName = this.auth.membersRusUser.firstName
              this.current_member.lastName = this.auth.membersRusUser.lastName
              this.current_member.id = this.auth.membersRusUser.id
              this.current_member.gender = this.auth.membersRusUser.gender
              this.clothesAdminList.getDiscountLeft()
            },500);
        }
      } else{
        this.isOpen = false;
      }
    })
  }

  clearMember(){
    this.current_member ={
      firstName: "",
      lastName: "",
      id: -1
    };
    this.clothesAdminList.clearCart();
  }

  clearStockUser(){
    this.stockUser ={
      firstName : "",
      lastName: "",
      id: "-1"
    };
  }

  checkIsAdmin(){
    if (this.noAdmin != null){
      return false;
    }else if (this.auth.isInRole("admin")) {
      return true;
    }
    return false

  }

  clearMemberEventHander($event: any) {
    this.clearMember()    ;
  }


  loadAllMembers(){
    this.memberService.getSimpleMembers().subscribe (res => {
      this.members = res;
    })
  }

  searchName(){
    if (this.nameSearchString.length > 0){
      this.firstnames = this.members.filter( a => a.firstName.toLowerCase().indexOf(this.nameSearchString.toLowerCase()) > -1) ;
      this.lastnames = this.members.filter( a => a.lastName.toLowerCase().indexOf(this.nameSearchString.toLowerCase()) > -1) ;
      this.searched_members = this.firstnames.concat(this.lastnames);
    }else{
      this.searched_members = this.members
    }
 }


  selectedMember(id: number){
    if (id > 0){
      let m = this.members.filter( a => a.id == id);
      if (m.length > 0){
        this.current_member = m[0]
      }
      else {
        this.current_member = {
          firstName : "",
          lastName: "",
          gender:""
        }
      }
    }
  }

  loadStockUser(){
    this.stockService.getStockUser().subscribe( x =>{
      if (x.status == 200) {
        this.stockUser = x.value;
      } else{
        this.clearStockUser();
      }
    })
  }


  StockSelected(){
    console.log("stock selected");
    this.current_member = this.stockUser
  }

  showModal(imgpath: string){
    var img = document.getElementById('sizeTableImg') as HTMLImageElement;
    img.src = imgpath;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/order-from/order-form.component.ts